import { createGenericTemporaryFormStore } from './factories/genericTemporaryStore';
import { JobSiteFormData } from '@/jobSites/application/types/JobSiteTypes';

export const useJobSiteTemporaryFormStore = createGenericTemporaryFormStore<JobSiteFormData>('JobSiteTemporaryFormStore');
